<template>
    <div class="account-container">
        <!-- Modal -->
        <div class="modal fade" id="addressModal" tabindex="-1" role="dialog" aria-labelledby="addressModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Dirección</h5>
                        <button type="button" class="close form4" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="editAccount('form-4')" data-vv-scope="form-4">
                            <div class="form-group">
                                <label class="form-label" for="addressType">Tipo de dirección</label>
                                <select data-vv-scope="form-4" @change="address.addresstype.type = setTypeName($event)" v-model="address.addresstype.idaddresstype" name="addressType" class="form-control" id="addressType">
                                    <option value="1">Casa</option>
                                    <option value="2">Oficina</option>
                                    <option value="3">Otro</option>
                                </select>
                            </div>
                            <div class="form-row">
                                <div class="col-md-12">
                                    <label for="" class="form-label">Código Postal</label>
                                    <input v-model="address.zipcode" data-vv-scope="form-4" name="zipcode" type="text" class="form-control" id="zipcode" placeholder="12345">
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="form-label" for="state">Provincia / Estado</label>
                                <select data-vv-scope="form-4" @change="address.state.statename = setTypeName($event); setCity(); setDistrict(); setNeighborhood();" v-model="address.state.idstate" name="state" class="form-control" id="state">
                                    <option v-for="state in locations.default" :value="state.id" :key="state.id">
                                        {{ state.label }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label class="form-label" for="canton">Cantón</label>
                                <select data-vv-scope="form-4" @change="setDistrict()" v-model="address.canton" name="canton" class="form-control" id="canton">
                                    <option v-for="canton in cities" :value="canton.id" :key="canton.id">
                                        {{ canton.label }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label class="form-label" for="district">Distrito</label>
                                <select data-vv-scope="form-4" @change="setNeighborhood()" v-model="address.distrito" name="district" class="form-control" id="district">
                                    <option v-for="district in districts" :value="district.id" :key="district.id">
                                        {{ district.label }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label class="form-label" for="neighborhood">Barrio</label>
                                <select data-vv-scope="form-4" v-model="address.barrio" name="addressType" class="form-control" id="neighborhood">
                                    <option v-for="neighborhood in neighborhoods" :value="neighborhood.id" :key="neighborhood.id">
                                        {{ neighborhood.label }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-row">
                                <div class="col-md-12">
                                    <label for="" class="form-label">Otras señas</label>
                                    <input :class="{ 'is-invalid': submitted && errors.has('form-4.direction') }" v-validate="{ required: true }" v-model="address.direccion" data-vv-scope="form-4" name="direction" type="text" class="form-control" id="direction" placeholder="">
                                    <div v-if="submitted && errors.has('form-4.direction')" class="invalid-feedback">{{ errors.first('form-4.direction') }}</div>
                                </div>
                            </div>
                            <div>
                                <button class="btn btn-primary">Agregar</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="container account" v-if="user.Consignee">
            <div class="icon-header-container">
                <figure class="icon-page-header">
                    <img src="/wp-content/uploads/2018/10/page-icon.png" alt="">
                </figure>
                <h1 class="principal-page-title principal-page-title-account">Mi cuenta</h1>
            </div>
            <!--<h2>Hola {{ $auth.user().email }}</h2>-->
            <div class="row">
                <div class="col-md-6">
                    <h2>Hola, {{ user.Consignee.consigneename }} !</h2>
                </div>
                <div v-if="user.PendingDiscount" class="col-md-6 readable-discount-panel">
                    <div class="d-flex readable-discount-panel-title">
                        <img src="../assets/discount-icon.png" alt="Icono de descuento">
                        <h5>Descuento pendiente:</h5>
                    </div>
                    <p class="readable-discount-panel-description">
                        CRBOX te recuerda que tienes
                        <span class="font-weight-bold">
                            {{user.PendingDiscount.Discount.ReadableDiscountAmount}}
                        </span>
                        de descuento en el flete aéreo el cual se aplicara automáticamente en tu
                        próximo pedido.
                    </p>
                </div>
            </div>
            <div class="row my-account">
                <div class="col-md-6">
                    <div v-if="!editMode" class="info">
                        <h4>Información de la cuenta <span class="green edit-profile"><a @click="editMode = true">Editar</a></span></h4>
                        <p>Su número de cuenta es: {{ user.Consignee.idconsignee }} </p>
                        <p>Correo electrónico: {{ user.Consignee.email }} </p>
                        <p>Sucursal {{user.Consignee.sucursal._name}}</p>
                    </div>
                    <div v-if="editMode" class="edit form-container" ref="editForm">
                        <form @submit.prevent="editAccount('form-3')" data-vv-scope="form-3">
                            <div class="form-row">
                                <div class="col-md-12">
                                    <h2>Editar información de la cuenta</h2>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-md-12">
                                    <label for="" class="form-label">Código especial</label>
                                    <input v-model="user.CompanyCode" type="text" class="form-control"  name="specialCode" placeholder="000-000">
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-md-12">
                                    <label v-if="!user.Consignee.isCompany" for="" class="form-label">Nombre *</label>
                                    <label v-if="user.Consignee.isCompany" for="" class="form-label">Nombre de la empresa *</label>
                                    <input v-model="user.Consignee.consigneename" data-vv-scope="form-3" v-validate="'required'" name="firstName" type="text" :class="{ 'is-invalid': submitted && errors.has('form-3.firstName') }" class="form-control" placeholder="">
                                    <div v-if="submitted && errors.has('form-3.firstName')" class="invalid-feedback">{{ errors.first('form-3.firstName') }}</div>
                                </div>
                            </div>
                            <div class="form-row" v-if="!user.Consignee.isCompany">
                                <div class="col-md-12">
                                    <label for="" class="form-label">Primer apellido *</label>
                                    <input v-model="user.Consignee.consigneelastname1" data-vv-scope="form-3" v-validate="user.Consignee.isCompany == false ? { required: true } : null" name="apellido1" class="form-control" :class="{ 'is-invalid': submitted && errors.has('form-3.apellido1') }">
                                    <div v-if="submitted && errors.has('form-3.apellido1')" class="invalid-feedback">{{ errors.first('form-3.apellido1') }}</div>
                                </div>
                            </div>
                            <div class="form-row" v-if="!user.Consignee.isCompany">
                                <div class="col-md-12">
                                    <label for="" class="form-label">Segundo apellido *</label>
                                    <input v-model="user.Consignee.consigneelastname2" data-vv-scope="form-3" v-validate="user.Consignee.isCompany == false ? { required: true } : null" type="text" name="lastName2" class="form-control" :class="{ 'is-invalid': submitted && errors.has('form-3.lastName2') }">
                                    <div v-if="submitted && errors.has('form-3.lastName2')" class="invalid-feedback">{{ errors.first('form-3.lastName2') }}</div>
                                </div>
                            </div>
                            <div class="form-row" v-if="!user.Consignee.isCompany">
                                <div class="col-md-12">
                                    <label for="" class="form-label">Fecha de nacimiento *</label>
                                    <input v-model="user.Consignee.birthDate" data-vv-scope="form-3" type="date" name="birthDate" class="form-control" :class="{ 'is-invalid': submitted && errors.has('form-3.birthDate') }" >
                                    <div v-if="submitted && errors.has('form-3.birthDate')" class="invalid-feedback">{{ errors.first('form-3.birthDate') }}</div>
                                </div>
                            </div>
                            <div v-if="!user.Consignee.isCompany" class="form-row">
                                <div class="col-md-12">
                                    <label for="" class="form-label">Correo electrónico</label>
                                    <input v-model="user.Consignee.email" data-vv-scope="form-3" v-validate="'required|email'" name="email" class="form-control" :class="{ 'is-invalid': submitted && errors.has('form-3.email') }" id="inputEmail" placeholder="nombre@email.com">
                                    <div v-if="submitted && errors.has('form-3.email')" class="invalid-feedback">{{ errors.first('form-3.email') }}</div>
                                </div>
                            </div>
                            <div class="form-row" v-if="user.Consignee.isCompany">
                                <div class="col-md-12">
                                    <label for="" class="form-label">Contacto de facturación *</label>
                                    <input v-model="user.Consignee.contactName1" data-vv-scope="form-3" v-validate="user.Consignee.isCompany ? 'required' : null" name="contact1" class="form-control" :class="{ 'is-invalid': submitted && errors.has('form-3.contact1') }" placeholder="">
                                    <div v-if="submitted && errors.has('form-3.contact1')" class="invalid-feedback">{{ errors.first('form-3.contact1') }}</div>
                                </div>
                            </div>
                            <div class="form-row" v-if="user.Consignee.isCompany">
                                <div class="col-md-12">
                                    <label for="" class="form-label">Correo de facturación *</label>
                                    <input v-model="user.Consignee.email" data-vv-scope="form-3" v-validate="user.Consignee.isCompany ? 'required|email' : null" name="emailContactOne" class="form-control" :class="{ 'is-invalid': submitted && errors.has('form-3.emailContactOne') }" placeholder="nombre@email.com">
                                    <div v-if="submitted && errors.has('form-3.emailContactOne')" class="invalid-feedback">{{ errors.first('form-3.emailContactOne') }}</div>
                                </div>
                            </div>
                            <div class="form-row" v-if="user.Consignee.isCompany">
                                <div class="col-md-12">
                                    <label for="" class="form-label">Nombre Contacto #2 *</label>
                                    <input v-model="user.Consignee.contactName2" data-vv-scope="form-3" v-validate="user.Consignee.isCompany ? 'required' : null" name="contact2" class="form-control" :class="{ 'is-invalid': submitted && errors.has('form-3.contact2') }" placeholder="">
                                    <div v-if="submitted && errors.has('form-3.contact2')" class="invalid-feedback">{{ errors.first('form-3.contact2') }}</div>
                                </div>
                            </div>
                            <div class="form-row" v-if="user.Consignee.isCompany">
                                <div class="col-md-12">
                                    <label for="" class="form-label">Correo Contact #2 *</label>
                                    <input v-model="user.Consignee.alternativeEmail" data-vv-scope="form-3" v-validate="user.Consignee.isCompany ? 'required|email' : null" name="emailContact2" class="form-control" :class="{ 'is-invalid': submitted && errors.has('form-3.emailContact2') }" placeholder="nombre@email.com">
                                    <div v-if="submitted && errors.has('form-3.emailContact2')" class="invalid-feedback">{{ errors.first('form-3.emailContact2') }}</div>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-md-12">
                                    <label for="" class="form-label">Contraseña</label>
                                    <input v-model="user.Password" type="password" name="password" class="form-control" id="password" placeholder="Si desea cambiar la contraseña ingresela aquí">
                                </div>
                            </div>
                            <div class="form-group" v-if="!user.Consignee.isCompany">
                                <label class="form-label" for="exampleFormControlSelect1">Tipo de identificación</label>
                                <select v-model="user.Consignee.identificationtype" @change="user.Consignee.identificationtype == 'Pasaporte' ? user.Consignee.responsabilidad = 0 : user.Consignee.responsabilidad = ''" class="form-control" id="exampleFormControlSelect1">
                                    <option value="Cedula ó Residencia">Física</option>
                                    <option value="Pasaporte">Extranjero</option>
                                    <option value="Otro">Otro</option>
                                </select>
                            </div>
                            <div class="form-row">
                                <div class="col-md-12">
                                    <label for="" class="form-label">Numero de identificación *</label>
                                    <input 
                                        v-model="user.Consignee.identificationnumber" 
                                        v-validate="user.Consignee.isCompany ? { required: true, regex: constants.ID_ENTERPRISE_REGEX } : 
                                        user.Consignee.identificationtype == 'Cedula ó Residencia' ? { required: true, regex: constants.ID_NUMBER_REGEX } :
                                        user.Consignee.identificationtype == 'Pasaporte' ? { required: false } :
                                        user.Consignee.identificationtype == 'Otro' ? { required: true, regex: constants.ID_ENTERPRISE_REGEX } : 
                                        user.Consignee.identificationtype == '' ? { required: true, regex: constants.ID_ENTERPRISE_REGEX } : null"
                                        :disabled="user.Consignee.identificationtype == 'Pasaporte'"
                                        :class="{ 'is-invalid': submitted && errors.has('form-3.IdNumber') }" 
                                        name="IdNumber" 
                                        type="text" 
                                        class="form-control" 
                                        id="idNumber"
                                        data-vv-scope="form-3" 
                                        :placeholder="user.Consignee.isCompany ? 'ej: 3101121231' :
                                        user.Consignee.identificationtype == 'Cedula ó Residencia' ? 'ej: 101230456' :
                                        user.Consignee.identificationtype == 'Otro' ? 'ej: 1012304565' : null"
                                        >
                                    
                                    <div v-if="submitted && errors.has('form-3.IdNumber')" class="invalid-feedback">{{ errors.first('form-3.IdNumber') }}</div>
                                </div>
                            </div>
                            <div v-if="user.Consignee.identificationtype == 'Pasaporte'" class="form-group">
                                <label class="form-label" for="responsabilidad">Responsabilidad *</label>
                                <select v-model="user.Consignee.responsabilidad" class="form-control" id="responsabilidad">
                                    <option value="0">Dimex</option>
                                    <option value="1">Nite</option>
                                </select>
                            </div>
                            <div v-if="user.Consignee.identificationtype == 'Pasaporte'" class="form-row">
                                <div class="col-md-12">
                                    <label for="" class="form-label">Numero de identificación *</label>
                                    <input 
                                    @change="user.Consignee.identificationnumber = Consignee.idResponsabilidad" 
                                    v-model="user.Consignee.idResponsabilidad" 
                                    v-validate="user.Consignee.responsabilidad == 0 ? { required: true, regex: constants.DIMEX } :
                                    Consignee.responsabilidad == 1 ? { required: true, regex: constants.NITE } : null" 
                                    name="passportNumber" 
                                    type="text" 
                                    class="form-control" 
                                    id="idNumber2"
                                    data-vv-scope="form-3"
                                    :class="{ 'is-invalid': submitted && errors.has('form-3.passportNumber') }"  
                                    :placeholder="user.Consignee.responsabilidad == 0 ? 'De 11 a 12 dígitos y no empezar con 0' : 'Número de 10 dígitos' ">
                                    <div v-if="submitted && errors.has('form-3.passportNumber')" class="invalid-feedback">{{ errors.first('form-3.passportNumber') }}</div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="form-label" for="idSucursal">Sucursal o servicio de entrega</label>
                                <select v-model="user.Consignee.sucursal._idsucursal" class="form-control" id="idSucursal">
                                    <option value="1">Sabana Norte (Oficina Central)</option>
                                    <option value="12">Guadalupe/Calle Blancos</option>
                                    <option value="13">Entrega a domicilio</option>
                                    <option value="14">Guachipelín Escazú / Distrito 4</option>
                                </select>
                            </div>
                            <div v-for="(phone, index) in user.Consignee.phones" :key="phone.idphone">
                                <h4 for="" class="">Número de teléfono {{index + 1}}</h4>
                                <div class="form-row">
                                    <div class="col-md-12">
                                        <label for="" class="form-label">Número de teléfono <span v-if="index == 0">*</span></label>
                                        <input v-model="phone.phonenumber" data-vv-scope="form-3" v-validate="{ required: true, regex: /^\d{8}$/ }" :class="{ 'is-invalid': submitted && errors.has('form-3.phoneNumber') }" name="phoneNumber" type="text" class="form-control" id="phoneNumber" placeholder="88888888">
                                        <div v-if="submitted && errors.has('form-3.phoneNumber')" class="invalid-feedback">{{ errors.first('form-3.phoneNumber') }}</div>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-md-12">
                                        <label for="" class="form-label">Extensión de teléfono <span v-if="index == 0">*</span></label>
                                        <input v-model="phone.phoneextension" name="extensionNumber" type="text" class="form-control" id="extensionNumber" placeholder="506">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="form-label" for="phoneType">Tipo de teléfono</label>
                                    <select v-validate="'required'" data-vv-scope="form-3" @change="phone.phonetype.type = setTypeName($event, index)" v-model="phone.phonetype.idphonetype" :class="{ 'is-invalid': submitted && errors.has('form-3.phoneType') }" name="phoneType" class="form-control" id="phoneType">
                                        <option value="1">Celular</option>
                                        <option value="2">Casa</option>
                                        <option value="3">Oficina</option>
                                        <option value="4">Fax</option>
                                    </select>
                                    <div v-if="submitted && errors.has('form-3.phoneType')" class="invalid-feedback">{{ errors.first('form-3.phoneType') }}</div>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-md-12">
                                    <label for="" class="form-label">Direcciones</label>
                                </div>
                            </div>
                            <div class="form-row" v-for="(address, index) in user.Consignee.addresses" :key="index">
                                <div class="col-md-12">
                                    <div class="add-info flex-row">
                                        <div @click="addAddress" class="circle-number flex-row" v-if="index == user.Consignee.addresses.length - 1">
                                            <span>+</span>
                                        </div>
                                        <input v-model="address.line1" @click="selectedAddressIndex = index; populateAddressInfo()" data-toggle="modal" data-target="#addressModal" v-validate="index == -1 ? { required: true } : null" :class="{ 'is-invalid': submitted && errors.has('form-3.showAddress' + ( index + 1 )) }" data-vv-scope="form-3"  :name="'showAddress' + ( index + 1 )" type="text" class="form-control">
                                        <div v-if="user.Consignee.addresses.length > 1" class="delete-button" @click="deleteAddress(address, index)">
                                            <i class="fa fa-times-circle" aria-hidden="true"></i>
                                        </div>
                                        <div v-if="submitted && errors.has('form-3.showAddress' + ( index + 1 ))" class="invalid-feedback">{{ errors.first('form-3.showAddress' + ( index + 1 )) }}</div>
                                    </div>
                                </div>
                            </div>
                             <div class="form-group">
                                <input type="checkbox" id="receivesNewsletter" v-model="user.Consignee.receivesNewsletter">
                                <label class="form-label" for="receivesNewsletter">Recibir correos de información</label>
                            </div>
                            <div class="form-group">
                                <input type="checkbox" id="obligadoTributario" v-model="declara">
                                <label class="form-label" for="obligadoTributario">Obligado tributario</label>
                            </div>
                            <div>
                                <button class="btn btn-primary">Agregar</button>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="col-md-6">
                    <h4>Recuerde que para iniciar la importación de sus paquetes debe utilizar la siguiente dirección:</h4>
                    <p>Apellido: {{ user.Consignee.consigneelastname1 }}</p>
                    <p>Nombre: {{ user.Consignee.consigneename }}</p>
                    <p>Address1: 8155 NW 68TH ST</p>
                    <p>Address2: {{user.Consignee.idconsignee}}</p>
                    <p>State: Florida</p>
                    <p>City: Miami</p>
                    <p>Zip Code: 33166</p>
                    <p>Tel: 305 882 1718</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import * as CrboxApi from '../services/CrboxApi.js';
import * as locations from '../services/ubicaciones.json';
import CrboxLoader from './components/crboxLoader.vue';
import * as regexConstants from '@/constants/regex'
export default {
    
  name: 'Dashboard',
  data: () => {
    return { 
        user: {},
        selectedAddressIndex: '', 
        paquetes: {},
        editMode: false,
        submitted: false,
        cities: [],
        districts: [],
        neighborhoods: [],
        locations: locations,
        address: {
            addresstype : {
                idaddresstype: 1,
                type: 'Casa',
            },
            barrio: '',
            canton: '',
            city: '',
            direccion: '',
            distrito: '',
            idaddress: '',
            line1: '',
            line2: '',
            provincia: '',
            state: {
                idstate: 1,
                statename: 'San josé'
            },
            zipcode: ''
        },
        declara: null,
        constants: { ...regexConstants },
    }
  },
  props:{
    edit: {type: Boolean, default: false},
  },
  components: {
      CrboxLoader
  },
  mounted() {
    this.getUsers();
  },
  created(){
      this.editMode = this.edit
  },
  computed: {
      getOmitirReceptor(){
          return this.declara ? 'N' : 'S'
      }
  },
  methods:{
    deleteAddress(address, index){
        CrboxApi.deleteAddress(this, this.user.Consignee.idconsignee, address.idaddress)
        .then((response) => {
            if(response.data.StatusResult == "OK"){
                this.user.Consignee.addresses.splice(index, 1);
            }            
        })
        .catch(()=>{
            this.$notify({
                group: 'notifications',
                type: 'error',
                title: 'Dirección',
                text: 'Ocurrió un error al borrar la dirección',
                duration: 4000,
                speed: 1000
            });
        })
    },
    addAddress() {
        this.address = {
            addresstype : {
                idaddresstype: 1,
                type: 'Casa',
            },
            barrio: '',
            canton: '',
            city: '',
            direccion: '',
            distrito: '',
            idaddress: '',
            line1: '',
            line2: '',
            provincia: '',
            state: {
                idstate: 1,
                statename: 'San josé'
            },
            zipcode: ''
        };
        this.address.idaddress = this.user.Consignee.addresses[this.user.Consignee.addresses.length - 1].idaddress;
        this.user.Consignee.addresses.push(this.address);
    },
    populateAddressInfo() {
        let empty = true;
        if(this.user.Consignee.addresses[this.selectedAddressIndex] != undefined || this.user.Consignee.addresses[this.selectedAddressIndex] != null){
            empty = false;
        }
        this.address = this.user.Consignee.addresses[this.selectedAddressIndex];
        this.setCity(empty);
        this.setDistrict(empty);
        this.setNeighborhood(empty);
    },
      getUsers: function () {
        let loader = this.$loading.show({
            container: null,
            opacity: 1
        },{
            default: this.$createElement('crbox-loader'),
        });
        CrboxApi.getUserInfo(this,this.$auth.user().email)
        .then((response) => {
            // handle success
            this.user = response.data;

            if (this.user.Consignee.birthDate) {
                this.user.Consignee.birthDate = this.user.Consignee.birthDate.split("T")[0];
            }   

            this.formatObligadoTributario()
            loader.hide();
        })
        .catch((response) => {
            this.$auth.logout();
            loader.hide();
        })
    },
    setTypeName(e, index) {
        return e.target.options[e.target.selectedIndex].text;
    },
    setCity(empty) {
        this.cities = this.locations.default[this.address.state.idstate - 1].cantones;
        if(empty){
            this.address.canton = this.cities[0].id;
        }
    },
    setDistrict(empty) {
        this.districts = this.cities[this.address.canton - 1].distritos;
        if(empty){
            this.address.distrito = this.districts[0].id;
        }
    },
    setNeighborhood(empty) {
        this.neighborhoods = this.districts[this.address.distrito - 1].barrios;
        if(empty){
            this.address.barrio = this.neighborhoods[0].id;
        }
    },
    saveAddressData() {
        this.user.Consignee.addresses[this.selectedAddressIndex] = this.address;
        this.user.Consignee.addresses[this.selectedAddressIndex].provincia = this.address.state.idstate;
        this.user.Consignee.addresses[this.selectedAddressIndex].city = this.locations.default[this.address.state.idstate - 1].cantones[this.address.canton - 1].label;
        this.user.Consignee.addresses[this.selectedAddressIndex].line1 = this.address.state.statename + ' ' + this.locations.default[this.address.state.idstate - 1].cantones[this.address.canton - 1].label + ' ' + this.cities[this.address.canton - 1].distritos[this.address.distrito - 1].label + ' ' + this.districts[this.address.distrito - 1].barrios[this.address.barrio].label + ' ' + this.address.direccion;

        this.address = {
            addresstype : {
                idaddresstype: 1,
                type: 'Casa',
            },
            barrio: '',
            canton: '',
            city: '',
            direccion: '',
            distrito: '',
            idaddress: '',
            line1: '',
            line2: '',
            provincia: '',
            state: {
                idstate: 1,
                statename: 'San josé'
            },
            zipcode: ''
        };
    },
    editAccount(scope) {
        this.submitted = true;
        this.$validator.validateAll(scope).then(valid => {
            if (valid) {
                if(scope == 'form-4'){
                    this.saveAddressData();
                    document.querySelector('.close.form4').click();
                    this.$validator.reset();
                }
                if(scope == 'form-3'){
                    this.user.ConfirmPassword = this.user.Password;
                    this.user.ConfirmEmail = this.user.Consignee.email;
                    let loader = this.$loading.show({
                        container: this.$refs.editForm
                    });
                    CrboxApi.postEditUser(this, this.user.Consignee, this.user.ConfirmEmail, this.user.Password, this.user.ConfirmPassword, this.user.CompanyCode, this.user.Consignee.phones, this.user.Consignee.addresses, this.getOmitirReceptor)
                    .then((response) => {
                        if(response.data.StatusResult == "OK"){
                            this.$notify({
                                group: 'notifications',
                                type: 'success',
                                title: 'Editar información',
                                text: "La información ha sido actualizada",
                                duration: 4000,
                                speed: 1000
                            })
                        }else if(response.data.StatusResult == "ERROR"){
                            this.$notify({
                                group: 'notifications',
                                type: 'error',
                                title: 'Editar información',
                                text: response.data.Message,
                                duration: 4000,
                                speed: 1000
                            })
                        }
                        loader.hide();
                    })
                    .catch((response) => {
                        this.$notify({
                            group: 'notifications',
                            type: 'error',
                            title: 'Editar información',
                            text: "Ha ocurrido un error al actualizar la información",
                            duration: 4000,
                            speed: 1000
                        });
                        loader.hide();
                    })
                }
            }
            else{
                this.$notify({
                    group: 'notifications',
                    type: 'error',
                    title: 'Editar información',
                    text: "Debe llenar todos los campos requeridos, por favor revise el formulario",
                    duration: 4000,
                    speed: 1000
                });
            }
        });
    },
    formatObligadoTributario(){
        const { omitirReceptor } = this.user.Consignee
        this.declara = omitirReceptor == null ? true : omitirReceptor == 'S' ? false : true 
    }    
  }
}
</script>